import { SxProps, Theme } from '@mui/material';

const selectedItem: SxProps<Theme> = (theme) => ({
  borderLeft: '3px solid',
  borderColor: theme.palette.primary.main,
});

const viewAllLink: SxProps<Theme> = (theme) => ({
  color: theme.palette.primary.main,
  textAlign: 'center',
});

const alignedCentered: SxProps<Theme> = {
  textAlign: 'center',
};

export default { selectedItem, viewAllLink, alignedCentered };
